import { markPwaInstallationObserved } from './pwa';

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
}

type InstallPromptListener = (event: BeforeInstallPromptEvent | null) => void;

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;
let isCaptureInitialized = false;
const listeners = new Set<InstallPromptListener>();

export function capturePwaInstallPrompt(): void {
  if (isCaptureInitialized) {
    return;
  }

  isCaptureInitialized = true;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    const installPrompt = event as BeforeInstallPromptEvent;
    deferredInstallPrompt = installPrompt;
    listeners.forEach((listener) => listener(installPrompt));
  });
  window.addEventListener('appinstalled', markPwaInstallationObserved);
}

export function getDeferredPwaInstallPrompt(): BeforeInstallPromptEvent | null {
  return deferredInstallPrompt;
}

export function clearDeferredPwaInstallPrompt(): void {
  deferredInstallPrompt = null;
  listeners.forEach((listener) => listener(null));
}

export function subscribeToPwaInstallPrompt(listener: InstallPromptListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
